var map = {
	"./TermsAndPolicy.tsx": 98993,
	"./additionalShampoo.tsx": 20781,
	"./aga.tsx": 74898,
	"./auth.tsx": 74637,
	"./automaticPlan.tsx": 95392,
	"./chat.tsx": 99043,
	"./error.tsx": 1672,
	"./flow.tsx": 21217,
	"./karte-plan.tsx": 79755,
	"./myPage.tsx": 12170,
	"./notFound.tsx": 54719,
	"./notication.tsx": 11216,
	"./payment.tsx": 83596,
	"./regularShampoo.tsx": 23228,
	"./video.tsx": 85568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93319;